export function checkEqualArrays(array1, array2) {
  if(!array1 && !array2) return true
  const sorted_array1 = array1.sort()
  const sorted_array2 = array2.sort()

  return JSON.stringify(sorted_array1) === JSON.stringify(sorted_array2)
}